/* eslint-disable react/display-name*/
import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Grid from "@mui/material/Grid";
import PDialog from "../../components/pos/PDialog";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function VendortransactionList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitle] = useState(
    translate("Vendor Transactions")
  );
  const [id, setId] = useState("");
  const [ledgerId, setLedgerId] = useState("");
  const [name, setName] = useState("");

  const [searchStr, setSearchStr] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 162) / 33)
  );

  useEffect(() => {}, []);

  props.biRef.transactions = {
    showTransactionList: showTransactionList,
  };

  function showTransactionList(vendorId, vendorLedgerId, name) {
    setOpenWindow(true);
    setId(vendorId);
    setLedgerId(vendorLedgerId);
    setName(name);
    loadData(vendorId, vendorLedgerId);
  }
  function onCloseWindow() {
    setOpenWindow(false);
  }

  async function loadData(vendorId, ledgerId) {
    let sort = '[{id:"date",sortOrder:"DESC"}]';
    loadByRest(0, rowLimitPerPage, sort, "[]", vendorId, ledgerId);
    //loaadByDB();
  }
  async function loadByRest(
    curPage,
    pageSize,
    sort,
    filter,
    vendorId,
    ledgerId
  ) {
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/vendorTransaction/list/" +
        vendorId +
        "/" +
        ledgerId +
        "?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }
  async function loaadByDB() {
    db.customertransaction.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    console.log(tableState.sortOrder);
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"orderId",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"voucherNumber",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(
      tableState.page,
      tableState.rowsPerPage,
      sort,
      search,
      id,
      ledgerId
    );
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: "350px",

    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={customertransactionListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function formatDate(date) {
    let formatted =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate());
    return formatted;
  }

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        align: "center",
        customBodyLite: (dataIndex) => {
          return formatDate(new Date(data[dataIndex].date));
        },
      },
    },
    {
      name: "transactionNum",
      label: translate("OrderId/VoucherNumber"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "type",
      label: translate("Type"),
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "amount",
      label: translate("Credit Amount"),
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({ align: "center" }),
        customBodyRenderLite: (dataIndex) => {
          let val =
            data[dataIndex].type == "Purchase"
              ? data[dataIndex].amountPaid
              : "";
          return val;
        },
      },
    },
    {
      name: "amount",
      label: translate("Debit Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex) => {
          let val =
            data[dataIndex].type === "Payment" ||
            data[dataIndex].type === "Return"
              ? data[dataIndex].amountPaid
              : "";
          return val;
        },
      },
    },
    {
      name: "mode",
      label: translate("Mode"),
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "remarks",
      label: translate("Remarks"),
      options: {
        filter: false,
        sort: true,
      },
    },
    /* {
      name: "action",
      label: "Actions",
      options: {
        /*
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={ {
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            } }
          >
            Edit
          </Button>
        ),
          
      },
    },*/
  ];
  const content = (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {name + " Transactions"}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      {/*<CustomertransactionCrud
      biRef={biRef}
      showMessage={props.showMessage}
      onRefresh={customertransactionListRefresh}
    ></CustomertransactionCrud>*/}
      {/**/}
    </Grid>
  );

  function customertransactionListRefresh() {
    loadData(id, ledgerId);
  }

  var biRef = {};

  return (
    <div>
      {openWindow && (
        <PDialog
          style={{ height: 650 }}
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          hideSave={true}
        ></PDialog>
      )}
    </div>
  );
}
